import { render, staticRenderFns } from "./CreditClassBySubjectTypeHorizontalBarChart.vue?vue&type=template&id=e9bd55d6&"
import script from "./CreditClassBySubjectTypeHorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./CreditClassBySubjectTypeHorizontalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports